import React from 'react'
import { Oval } from 'react-loader-spinner'

type Props = {
  size: number;
  color?: string;
}

export default function AppLoader({ size, color = '#aaa' }: Props) {
  return (
    <Oval
      height={size}
      width={size}
      color={color}
      secondaryColor="#ccc"
      ariaLabel='loading'
    />
  )
}